// Piezas de la venta que Zentral vendió, traspasó o retiró: cada una con su motivo y su salida.
import { AlertTriangle } from 'lucide-react';
import { Badge, Button } from '@/kit';
import { LOST_COPY, lostLineText } from '../integrationErrors';
import type { LostLineView } from '../lostLines';

export function LostLinesNotice({
    lines,
    onChoosePhone,
    onRemove,
    removingLineId,
}: {
    lines: readonly LostLineView[];
    onChoosePhone: () => void;
    onRemove: (lineId: string) => void;
    removingLineId?: string;
}) {
    if (lines.length === 0) return null;
    return (
        <div
            role="alert"
            className="flex items-start gap-3 rounded-lg border border-warning-soft-border bg-warning-soft p-3 text-warning"
        >
            <AlertTriangle className="mt-0.5 size-4 flex-none" aria-hidden />
            <div className="flex min-w-0 flex-1 flex-col gap-2 text-[12px] leading-relaxed">
                <p>{LOST_COPY.title}</p>
                <ul className="flex flex-col gap-2">
                    {lines.map((line) => (
                        <li key={line.lineId} className="flex flex-wrap items-center gap-2">
                            <Badge variant="destructive">{LOST_COPY.badge}</Badge>
                            <span className="min-w-0 flex-1">
                                {lostLineText(line.name, line.lostReason)}
                            </span>
                            {line.anchor ? (
                                <Button size="sm" variant="secondary" onClick={onChoosePhone}>
                                    {LOST_COPY.choosePhone}
                                </Button>
                            ) : (
                                <Button
                                    size="sm"
                                    variant="secondary"
                                    isLoading={removingLineId === line.lineId}
                                    onClick={() => {
                                        onRemove(line.lineId);
                                    }}
                                >
                                    {LOST_COPY.remove}
                                </Button>
                            )}
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}
